module.exports = __webpack_public_path__ + "style/img/Group 2258(5).8125c853.png";